import moment from 'moment';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { compose, withHandlers } from 'recompose';

import config from '../../../config';
import { getBarberId } from '../../barbers/selectors';
import { validatePrepayOnlyCustomer } from '../actions';
import { getIsFormValid, getPromoCode, getUser } from '../selectors';
import { getGiftCardEnabled, getShopId } from '../../shops/selectors';
import GuardedCheckoutButton from '../components/GuardedCheckoutButton';

export default compose(
  withRouter,
  connect(
    (state, ownProps) => ({
      shopId: getShopId(state, ownProps.params.shopRoute),
      barberId: getBarberId(state, ownProps.params.barberRoute),
      promoCode: getPromoCode(state),
      customer: getIsFormValid(state) ? getUser(state) : undefined,
      giftCardEnabled: getGiftCardEnabled(state, ownProps.params.shopRoute),
      dateTime: moment(ownProps.params.reservationTime, config.timeSlugFormat).toJSON(),
    }),
  ),
  withHandlers({
    validate: props => () => validatePrepayOnlyCustomer(props.dispatch)({
      ...props.customer,
      shopId: props.shopId,
      barberId: props.barberId,
      serviceCost: props.costWithTaxes,
      promoCode: props.promoCode,
      includeWaitingListFee: props.timeWaitingList,
      tipAmount: props.tipAmount,
      dateTime: props.dateTime,
      validatePrepayOnly: true,
    }),
  }),
)(GuardedCheckoutButton);



// WEBPACK FOOTER //
// ./src/app/reservation/containers/GuardedCheckoutButton.js